module.exports = __webpack_public_path__ + "img/icon-manual.bc46e1e3.svg";